import { render } from "./AcademicsNavBar.vue?vue&type=template&id=34e289d2&scoped=true"
import script from "./AcademicsNavBar.vue?vue&type=script&lang=js"
export * from "./AcademicsNavBar.vue?vue&type=script&lang=js"

import "./AcademicsNavBar.vue?vue&type=style&index=0&id=34e289d2&scoped=true&lang=css"
import "./AcademicsNavBar.vue?vue&type=style&index=1&id=34e289d2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e289d2"]])

export default __exports__